import { render, staticRenderFns } from "./RightShiftedContentBlock.vue?vue&type=template&id=53075a52"
import script from "./RightShiftedContentBlock.vue?vue&type=script&lang=js"
export * from "./RightShiftedContentBlock.vue?vue&type=script&lang=js"
import style0 from "./RightShiftedContentBlock.vue?vue&type=style&index=0&id=53075a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports